<template>
  <div class="hello">
    <h1>滚动条</h1>
    <h1>{{ msg }}</h1>
    <h2>Essential Links</h2>
    <el-checkbox v-model="checked">备选项</el-checkbox>
    <p></p>

    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="用户管理"
                   name="first">用户管理</el-tab-pane>
      <el-tab-pane label="配置管理"
                   name="second">配置管理</el-tab-pane>
      <el-tab-pane label="角色管理"
                   name="third">角色管理</el-tab-pane>
      <el-tab-pane label="定时任务补偿"
                   name="fourth">定时任务补偿</el-tab-pane>
    </el-tabs>
    <br>
    <br>
    <br>
    <el-button type="blue"
               @click="addTab(editableTabsValue)">增加标签页</el-button>
    <p></p>
    <el-tabs v-model="editableTabsValue"
             type="card"
             closable
             @tab-remove="removeTab">
      <el-tab-pane v-for="item in editableTabs"
                   :key="item.name"
                   :label="item.title"
                   :name="item.name">
        {{item.content}}
      </el-tab-pane>
    </el-tabs>
    <p>弹出框</p>
    <el-button type="text"
               @click="dialogVisible = true">点击打开 Dialog</el-button>
    <p></p>
    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               width="400px"
               modal
               :before-close="handleClose">
      <span>这是一段信息</span>
      <span slot="footer"
            class="dialog-footer">

        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
        <el-button type="default"
                   @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <h1>主要按钮</h1>
    <el-row>
      <el-button type="gray">灰色按钮</el-button>
      <el-button type="blue">蓝色按钮</el-button>
      <el-button type="green">绿色按钮</el-button>
      <el-button type="read">开始审阅</el-button>
      <el-button disabled>默认按钮</el-button>
    </el-row>
    <h1>多选按钮组</h1>
    <checkbox-tags :checkboxGroup="checkboxGroup"></checkbox-tags>
    <p>MessageBox</p>
    <el-button type="text"
               @click="open">点击打开 Message Box</el-button>
    <p>抽屉组件Drawer</p>
    <th-drawer></th-drawer>
  </div>
</template>

<script>
import SecondaryButton from '../button/SecondaryButton'
import CheckboxTags from '../checkboxtags/CheckboxTags'
import ThDrawer from '../drawer/thdrawer'
export default {
  name: 'demo',
  components: {
    SecondaryButton,
    CheckboxTags,
    ThDrawer
  },
  data () {
    return {
      num: 30,
      checkboxGroup: [
        {
          label: '刘大河',
          value: 1,
          checked: true,
        },
        {
          label: '刘武生',
          value: 2,
          checked: false,
        }, {
          label: '刘玄德',
          value: 3,
          checked: false,
        }],
      msg: 'Welcome to Your Vue.js App',
      checked: true,
      activeName: 'second',
      editableTabsValue: '2',
      editableTabs: [{
        title: 'Tab 1',
        name: '1',
        content: 'Tab 1 content'
      }, {
        title: 'Tab 2',
        name: '2',
        content: 'Tab 2 content'
      }],
      tabIndex: 2,
      dialogVisible: false
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    addTab (targetName) {
      let newTabName = ++this.tabIndex + ''
      this.editableTabs.push({
        title: 'New Tab',
        name: newTabName,
        content: 'New Tab content'
      })
      this.editableTabsValue = newTabName
    },
    removeTab (targetName) {
      let tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }

      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter(tab => tab.name !== targetName)
    },
    handleClose (done) {
      done()
    },
    getArr (v) {
      console.log(v)
    },
    open () {
      this.$confirm('重新生成文书后，将丢失手动修改的文书内容，信息不可恢复，请确认是否继续。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: "message-style",
        iconClass: 'iconfont el-icon-th-info',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.scrollbar_wrapper {
  height: 300px;
  overflow: hidden;
  .list {
    max-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/demo/demo.vue